export function readStored(key: string, persistent = false): unknown {
  try {
    const raw = (persistent ? localStorage : sessionStorage).getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
export function writeStored(
  key: string,
  value: unknown,
  persistent = false,
): void {
  try {
    (persistent ? localStorage : sessionStorage).setItem(
      key,
      JSON.stringify(value),
    );
  } catch {
    /* The workflow also works without browser storage. */
  }
}
